"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var axios_1 = __importDefault(require("axios"));
var invariant_1 = __importDefault(require("invariant"));
var lodash_1 = __importDefault(require("lodash"));
var Authentication_1 = __importDefault(require("./methods/Authentication"));
var Channels_1 = __importDefault(require("./methods/Channels"));
var Chat_1 = __importDefault(require("./methods/Chat"));
var Groups_1 = __importDefault(require("./methods/Groups"));
var Im_1 = __importDefault(require("./methods/Im"));
var Rooms_1 = __importDefault(require("./methods/Rooms"));
var Subscriptions_1 = __importDefault(require("./methods/Subscriptions"));
var Users_1 = __importDefault(require("./methods/Users"));
var Client = /** @class */ (function () {
    function Client(options) {
        this.version = 'v1';
        var url = options.url, _a = options.clientConfig, clientConfig = _a === void 0 ? {} : _a;
        invariant_1["default"](url, 'RocketChatClient: url is required');
        this.url = url;
        this.client = axios_1["default"].create(__assign(__assign({ timeout: 12000 }, clientConfig), { baseURL: this.url + "/api/" + this.version }));
        this.methods = __assign(__assign({}, Authentication_1["default"](this)), { rooms: Rooms_1["default"](this), channels: Channels_1["default"](this), chat: Chat_1["default"](this), im: Im_1["default"](this), users: Users_1["default"](this), groups: Groups_1["default"](this), subscriptions: Subscriptions_1["default"](this) });
    }
    Client.prototype.call = function (methodName, method, data) {
        if (method === void 0) { method = 'GET'; }
        if (data === void 0) { data = {}; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (lodash_1["default"].isPlainObject(method)) {
                            data = method;
                            method = 'GET';
                        }
                        return [4 /*yield*/, (method === 'POST')];
                    case 1: return [2 /*return*/, (_a.sent()) ? this.POST(methodName, data) : this.GET(methodName, data)];
                }
            });
        });
    };
    Client.prototype.POST = function (methodName, data) {
        if (data === void 0) { data = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var headers, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        headers = this.getHeaders();
                        return [4 /*yield*/, this.client.post(methodName, data, {
                                headers: headers
                            })];
                    case 1:
                        result = (_a.sent()).data;
                        return [2 /*return*/, result];
                }
            });
        });
    };
    Client.prototype.GET = function (methodName, params) {
        return __awaiter(this, void 0, void 0, function () {
            var headers, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        headers = this.getHeaders();
                        return [4 /*yield*/, this.client.get(methodName, { params: params, headers: headers })];
                    case 1:
                        result = (_a.sent()).data;
                        return [2 /*return*/, result];
                }
            });
        });
    };
    Client.prototype.setCredentials = function (_a) {
        var userId = _a.userId, authToken = _a.authToken;
        this.auth = { userId: userId, authToken: authToken };
        this.client.defaults.headers.common['X-User-Id'] = userId;
        this.client.defaults.headers.common['X-Auth-Token'] = authToken;
    };
    Client.prototype.getHeaders = function () {
        if (!this.auth)
            return {};
        var _a = this.auth, userId = _a.userId, authToken = _a.authToken;
        return { 'X-User-Id': userId, 'X-Auth-Token': authToken };
    };
    return Client;
}());
exports["default"] = Client;
